import { useEffect, useState , useRef} from "react";
import { Link } from "react-router-dom";
import { useSubmitRegisterFormMutation } from "../../../services/RegisterAPI";
import { useGetColorThemeQuery } from "../../../services/commonAPI";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

function Registerform() {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(null);
  const [captchaValue, setCaptchaValue] = useState(null);
  const recaptchaRef = useRef(null);
  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
    setErrors((prevErrors) => {

      const updatedErrors = { ...prevErrors };
      if (updatedErrors.captcha) {
          delete updatedErrors.captcha;
      }
      return updatedErrors;
  });
  };

  const { data: colorthemeData } = useGetColorThemeQuery();
  const [submitRegisterForm, { isLoading }] = useSubmitRegisterFormMutation();
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITEKEY;

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage(null);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [message]);

  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });

    // Clear the error message for the corresponding field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [e.target.name]: "",
    }));
  };

  // Password Validation
  const validateForm = () => {
    let newErrors = {};

    if (!formData.username || formData.username.length < 3) {
      newErrors.username = "Username must be at least 3 characters long.";
    }

    if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    // if (!formData.password) {
    //   newErrors.password = "Password is required.";
    // } else if (
    //   !/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}/.test(
    //     formData.password
    //   )
    // ) {
    //   newErrors.password =
    //     "Password must be at least 8 characters, include one uppercase, one lowercase, one number, and one special character.";
    // }

    // if (formData.password !== formData.confirmPassword) {
    //   newErrors.confirmPassword = "Passwords do not match.";
    // }

    if (!captchaValue) {
      newErrors.captcha = "Please verify the reCAPTCHA.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);

    if (!validateForm()) {
      return;
    }

    const updatedFormData = {
      username: formData.username,
      email: formData.email,
      password: formData.password,
      recaptchatoken: captchaValue,
    };

    try {
      const response = await submitRegisterForm(updatedFormData).unwrap();
      setMessage(response.message);
      setMessageType("success");
      setFormData({ username: "", email: "", password: "", confirmPassword: "" });
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
      setCaptchaValue("");
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } catch (error) {
      setMessage(error.data?.message || "Failed to Register.");
      setMessageType("error");
    }
  };

  const handleTextKeyPress = (e) => {
    if (!/^[a-zA-Z0-9\s]$/.test(e.key)) {
      e.preventDefault();
    }
  };
  
  const handleTextPaste = (field) => (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("Text");
    const cleanedText = pastedText.replace(/[^a-zA-Z0-9\s]/g, "");
    setFormData((prev) => ({ ...prev, [field]: cleanedText }));
  };


  return (
    <div className="register-form">
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-lg-6 col-sm-12">
            <div className="left-div">
              <h4>Register</h4>
              <form onSubmit={handleSubmit}>
                <div className="mb-20">
                  <label>Username *</label>
                  <br />
                  <input
                    type="text"
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    onKeyPress={handleTextKeyPress}
                    onPaste={handleTextPaste("username")}
                  />
                  {errors.username && <p className="error-text">{errors.username}</p>}
                </div>
                <div className="mb-20">
                  <label>Email Address *</label>
                  <br />
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && <p className="error-text">{errors.email}</p>}
                </div>
  
                <div className="mb-4">
                  <ReCAPTCHA sitekey={siteKey} onChange={handleCaptchaChange}  ref={recaptchaRef} />
                  {errors.captcha && <p className="error-text">{errors.captcha}</p>}
                </div>
                <p>
                  Your personal data will be used to support your experience
                  throughout this website, to manage access to your account, and
                  for other purposes described in our{" "}
                  <a href="/privacy-policy">Privacy policy.</a>
                </p>
                <button
                  type="submit"
                  className="primary-button w-100"
                  disabled={isLoading}
                  style={{ backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }}
                >
                  {isLoading ? "Submitting..." : "Submit"}
                </button>
              </form>
              {message && (
                <p
                  className={
                    messageType === "success"
                      ? "success-message"
                      : "error-message"
                  }
                >
                  {message}
                </p>
              )}
            </div>
          </div>
          <div className="col-md-6 col-lg-6 col-sm-12">
            <div className="right-div">
              <h4>Login</h4>
              <p>
                Login here by filling you're username and password or use your
                favorite social network account to enter to the site. Site login
                will simplify the purchase process and allows you to manage your
                personal account.
              </p>
              <Link to="/login">
                <button className="primary-button" style={{ backgroundColor: colorthemeData?.color_themes?.[0]?.primary_color || "#a76d50" }}>Login</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Registerform;
